export default "https://assets.egbcdn.net/assets/packs/_/sounds/incubator_suggestion-acf716ba544b2408c1a390599ee2c217.mp3";